export default __webpack_public_path__ + "static/media/zapsplat_household_alarm_clock_digital_beeps_001_60068.091b41e3.mp3";